<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="note.id">{{$t('modals.edit_note.title')}}</h1>
            <h1 v-else>{{$t('modals.create_note.title')}}</h1>
        </div>

        <note-form
            :note="note"
            :wrapperClass="['modal__content']"
            @saved="onNoteUpdated">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </note-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import NoteForm from '@/components/forms/dashboard/NoteForm';

    import { GET_NOTES } from '@/store/modules/notes';

    @Component({
        components: {
            NoteForm,
        }
    })
    export default class NoteModal extends Vue {
        name = 'note-modal';

        note = {};

        beforeOpen(event) {
            if (event.params && event.params.note) {
                this.note = event.params.note;
            }
        }

        onNoteUpdated() {
            this.$notify.success(this.$t('notify.note.save_success'));
            this.refetchAndClose();
        }

        refetchAndClose() {
            this.$store.dispatch(GET_NOTES, {});
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/NoteModal.vue